import { createContext } from 'react';
import type { Href } from '../types.js';

/** @internal */
export interface LinkTabsContextValue {
  isDisabled?: boolean;
  currentHref: Href | null;
  setCurrentHref: (href: Href | null) => void;
}

/** @internal */
export const LinkTabsContext = createContext<LinkTabsContextValue | null>(null);
